<template>
	<div class="three-meeting">
    <el-button type="primary" size="small" icon="el-icon-upload2" v-if="allData && allData.projectStatus !== 5" @click="openUpload()" style="margin-bottom: 10px">Upload</el-button>
    <el-table :data="tableData" border v-loading="tableLoading" style="width: 100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
      <el-table-column prop="id" label="id" v-if="false" ></el-table-column>
      <el-table-column prop="number" label="No." align="center" width="80"></el-table-column>
      <el-table-column prop="fileName" label="File Name" align="center" min-width="400">
        <template slot-scope="scope">
          <a style="color:blue;" @click="downloadFile(scope.row)">{{ scope.row.fileName }}</a>
        </template>
      </el-table-column>
      <el-table-column prop="updateDate" label="Update Date" align="center" min-width="150">
        <template v-slot="scope">
          {{ scope.row.updateDate ? moment(scope.row.updateDate).format('YYYY-MM-DD') : ''}}
        </template>
      </el-table-column>
      <el-table-column label="Operation" align="center" width="200">
        <template slot-scope="scope">
          <el-button size="small" type="primary" :disabled="scope.row.approvalStatus === 1" v-if="scope.row.sourceTable !== 'recordProjectFile' && allData && allData.projectStatus !== 5" @click="openUpload(scope.row)">Cover</el-button>
          <el-button size="small" type="danger"  :disabled="scope.row.approvalStatus === 1" v-if="scope.row.sourceTable !== 'recordProjectFile' && allData && allData.projectStatus !== 5" @click="handleDelete(scope.row)">Delete</el-button>
          <span v-if="scope.row.sourceTable === 'recordProjectFile'">History Records</span>
        </template>
      </el-table-column>
      <el-table-column label="Status" align="center" width="200" prop="documentApprovalStatusDesc" v-if="allData.majorProjectLevel && allData.majorProjectLevel !== 4">
      </el-table-column>
    </el-table>
    <div class="pageDiv" v-if="totalCount && totalCount > 0" style="padding-bottom: 6px">
      <el-pagination
        small
        layout="total, prev, pager, next, sizes, jumper"
        :page-sizes="[10, 20, 50, 100]"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="totalCount"
        @size-change="changePageSize"
        @current-change="changePage"
      >
      </el-pagination>
    </div>
		<el-dialog
			title="Upload"
			width="500px"
			:visible.sync="uploadVisible"
			:close-on-click-modal="false"
		>
			<el-form :model="uploadForm" ref="uploadForm" label-width="85px">
				<el-form-item label="File:" prop="file" :rules="[{ required: true, message: 'Please upload' }]">
          <el-upload
            class="upload-demo"
            action="#"
            :http-request="changeFile"
            :file-list="fileList"
            :show-file-list="false"
            :before-upload="beforeUpload"
            :limit="1"
            :on-exceed="handleExceed"
            v-model="uploadForm.file"
          >
            <el-button size="small" type="primary">Upload</el-button>
          </el-upload>
          <div class="el-upload-newlist">
            <div v-for="(item, index) in fileList" :key="index" class="el-upload-file-box">
              <a class="file-name"><i class="el-icon-document" />{{ item.name }}</a>
              <label>
                <span class="percentage" v-if="item.uploadPercentage > 0 && item.uploadPercentage < 100">{{ item.uploadPercentage }}%</span>
                <i class="el-icon-circle-check icon-check" style="color: #67c23a" v-if="item.id || item.uploadPercentage === 100"></i>
                <i class="el-icon-close icon-close" style="display: none" @click="handleRemove"></i>
              </label>
              <el-progress v-if="item.uploadPercentage > 0 && item.uploadPercentage < 100" :show-text="false" :stroke-width="2" :percentage="item.uploadPercentage"></el-progress>
            </div>
          </div>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="closeUpload()">Cancel</el-button>
				<el-button type="primary" :loading="confirmLoading" size="small" @click="confirmFile()">Confirm</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
  import moment from 'moment';
	import axios from 'axios'
  export default {
    name: 'threeMeeting',
		props: {
			id: {
        type: Number,
        default: null,
      },
			allData: {
				type: Object,
        default: {},
			},
		},
  watch: {
    allData(newValue, oldValue) {
      if(newValue.majorProjectLevel ) {
        this.handleSearch();
      }
    },
  },
    created () {
      // this.handleSearch();
    },
    data () {
      return {
        moment,
        tableData: [],
				tableLoading: false,
				currentPage: 1,
				pageSize: 10,
        totalCount: 0,
        uploadVisible: false,
        uploadForm: {},
        fileList: [],
        confirmLoading: false,
        cancelUpload: null,
      }
    },
    methods: {
      handleSearch() {
        let params = {
					islhToken : sessionStorage.getItem('islhtoken'),
					projectId: this.id,
          fileType: 10,
				}
				this.tableLoading = true;
				let url =`${this.$store.state.islhurl}projectFile/getListByPage/${this.pageSize}/${this.currentPage}`
        if(this.allData.majorProjectLevel && this.allData.majorProjectLevel !== 4) {
          url =`${this.$store.state.islhurl}projectFile/getDocumentUploadApproval/${this.pageSize}/${this.currentPage}`
        }
				this._post(url, params).then(
					res => {
						this.tableLoading = false;
						if(res.code === 200) {
              let newData = [];
							res.data.forEach((item, index) => {
								newData.push({
									...item,
									number: index + 1,
								})
							});
						  this.tableData = newData;
						  this.totalCount = res.totalNums;
						} else {
							this.tableData = [];
							this.$message.error(res.message || 'Failed!' );
						}
					}
				)
      },
			changePageSize(size) {
				this.pageSize = size;
				this.handleSearch();
			},
			changePage(current) {
				this.currentPage = current;
				this.handleSearch();
			},
      downloadFile(row) {
        if(row.fileAliasName && row.fileName) {
          window.open(`${this.$store.state.islhurl}s3/download?fileAliasName=${encodeURIComponent(row.fileAliasName)}&fileName=${encodeURIComponent(row.fileName)}`);
        }
      },
      openUpload(row) {
        this.uploadVisible = true;
        if(row && row.id) {
          this.uploadForm = {
            id: row.id
          };
        };
      },
      closeUpload() {
        this.uploadVisible = false;
        this.fileList = [];
        this.uploadForm = {};
      },
			beforeUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 200;
        if (!isLt2M) {
          this.$message.error('File cannot be larger than 200MB!');
          return false;
        }
      },
      handleExceed() {
        this.$message.warning('Only one file is allowed for upload.');
      },
			changeFile(row) {
				const file = row.file;
				let fd = new FormData();
				fd.append('file', file);
				let params = {
					islhToken: sessionStorage.getItem("islhtoken"),
				}
				fd.append('fileParam', new Blob([JSON.stringify(params)], {type: 'application/json'}));
				let url = `${this.$store.state.islhurl}s3/upload`
				// 创建 CancelToken
				const CancelToken = axios.CancelToken;
				const source = CancelToken.source();
				this.cancelUpload = source.cancel; // 存储取消函数
				this._post(url, fd, {
					cancelToken: source.token, // 绑定 CancelToken
					onUploadProgress: (percent) => {
						this.fileList = [{
							name: file.name,
							uid: file.uid,
							uploadPercentage: percent === 100 ? 99 : percent,
						}];
						// 通知Upload组件内部进度更新
					},
					noProgress: true // 禁用全局NProgress
				}).then(res => {
					if(res.code == 200) {
            this.fileList = [{
              ...file,
              name: file.name,
              uid: file.uid,
              id: res.data.id,
              fileId: res.data.id,
							uploadPercentage: 100,
            }];
            this.uploadForm = {
              ...this.uploadForm,
              file: file
            };
					} else {
						this.fileList = [];
						this.$message.error(res.message || 'Failed!' );
					}
				}).catch(error => {
					console.log(error)
					this.fileList = [];
				})
      },
			handleRemove() {
				if (typeof this.cancelUpload === 'function') {
					this.cancelUpload('User canceled upload');
					this.cancelUpload = null;
				}
				this.fileList = [];
				this.uploadForm = {
					...this.uploadForm,
					file: []
				};
			},
      handleDelete(row, type) {
        this.$confirm("Are you sure to delete the file", "Warning", {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          if(this.allData && this.allData.majorProjectLevel && this.allData.majorProjectLevel !== 4) {
            let url = `${this.$store.state.islhurl}projectFile/documentDeleteApproval`
            let params = {
              oldFileId: row.id,
              islhToken: sessionStorage.getItem("islhtoken"),
              eosToken: sessionStorage.getItem("eostoken"),
            }
            let fd = new FormData();
            fd.append('recordParam', new Blob([JSON.stringify(params)], {type: 'application/json'}))
            this._post(url, fd).then(
              res =>{
                if(res.code === 200) {
                  this.handleSearch();
                  this.$Message.success('Delete Successful' )
                } else {
                  this.$message({
                    type:'error',
                    message: res
                  });
                }
              }
            )
          } else {
            let url = `${this.$store.state.islhurl}projectFile/deleteFileById?idParam=${row.id}&&islhToken=${sessionStorage.getItem('islhtoken')}`
            this._post(url).then(
              res =>{
                if(res.code === 200) {
                  this.handleSearch();
                  this.$Message.success('Delete Successful' )
                } else {
                  this.$message({
                    type:'error',
                    message: res
                  });
                }
              }
            )
          }
        }).catch(() => {
        });
      },
      confirmFile() {
        this.$refs.uploadForm.validate((valid) => {
					if (valid) {
            let fd = new FormData();
            // fd.append('file', this.fileList[0].raw);
            let fileParam = {
              projectId: this.id,
              fileType: 10,
              islhToken: sessionStorage.getItem("islhtoken"),
            }
						if (this.fileList && this.fileList.length > 0) {
							fileParam.fileId = this.fileList[0].fileId;
            }
				    let url =`${this.$store.state.islhurl}projectFile/save-file`;
            if(this.uploadForm.id) {
              url =`${this.$store.state.islhurl}projectFile/editAndReplace`;
              fileParam.id = this.uploadForm.id;
            }
            if(this.allData && this.allData.majorProjectLevel && this.allData.majorProjectLevel !== 4) {
              fileParam.eosToken = sessionStorage.getItem("eostoken");
						  fd.append('recordParam', new Blob([JSON.stringify(fileParam)], {type: 'application/json'}))
              url =`${this.$store.state.islhurl}projectFile/documentUploadApproval`;
              if(this.uploadForm.id) {
                url =`${this.$store.state.islhurl}projectFile/documentCoverApproval`;
              }
            } else if (this.allData && this.allData.majorProjectLevel && this.allData.majorProjectLevel === 4 && this.uploadForm.id) {
              fd.append('fileParam', new Blob([JSON.stringify(fileParam)], {type: 'application/json'}))
            } else {
              fd = fileParam;
            }
						this.confirmLoading = true;
						this._post(url, fd).then(
							res => {
                this.confirmLoading = false;
								if(res.code === 200) {
									this.$Message.success('Upload successful!' );
                  this.handleSearch();
									this.closeUpload();
								} else {
									this.$message.error(res.message || 'Failed!' );
								}
							}
						)
					}
				});
      },
		},
  }
</script>
<style lang="less" scoped>
.el-upload-newlist {
	width: 300px;
	.el-upload-file-box {
		margin-top: 10px;
		border-radius: 4px;
		position: relative;
		line-height: 26px;
		.file-name {
			line-height: 26px;
			color: #606266;
			display: block;
			margin-right: 40px;
			overflow: hidden;
			padding-left: 4px;
			text-overflow: ellipsis;
			-webkit-transition: color .3s;
			transition: color .3s;
			white-space: nowrap;
      cursor: default;


			i {
				margin-right: 7px;
    		color: #909399;
			}
		}
		label {
			position: absolute;
			right: 5px;
			top: 0;
			line-height: inherit;
			i {
				line-height: 26px;
			}
			.icon-close {
				cursor: pointer;
			}
			.percentage {
				color: #666;
				font-size: 12px;
			}
		}
	}
	.el-upload-file-box:hover {
		background-color: #f5f7fa;
		.icon-check, .percentage {
			display: none;
		}
		.icon-close {
			display: block !important;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/view/major/hldlld/index.vue